import { Alert } from "@alm/flow-ds/components";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface Props {
	alert?: string;
	setAlert: Dispatch<SetStateAction<string | undefined>>;
	edit?: boolean;
	children?: React.ReactNode;
}

export default ({ alert, setAlert, edit, children }: Props) => {
	const { t } = useTranslation();

	// find admin main and scroll to the top if there is an alert
	useEffect(() => {
		if (alert) document.querySelector(".admin__main")?.scrollTo(0, 0);
	}, [alert]);

	return (
		<>
			<div className="admin__breadcrumb">
				<Link to="/admin/roles">{t("main.admin.headings.roles")}</Link>
				{" > "}
				{edit
					? t("main.admin.headings.editRole")
					: t("main.admin.headings.newRole")}
			</div>
			<div className="admin__title">
				<h2>
					{edit
						? t("main.admin.headings.editRole")
						: t("main.admin.headings.createNewRole")}
				</h2>
			</div>
			{alert && (
				<Alert
					className="validation-alert mt-3"
					title={t(`alerts.${alert}.title`)}
					block={true}
					description={t(`alerts.${alert}.description`)}
					status="error"
					onClose={() => setAlert(undefined)}
				/>
			)}
			<div className="admin__role-form">{children}</div>
		</>
	);
};
